import React, { useEffect } from 'react'
import { Box, Button } from '@mui/material'
import { useSelector } from 'react-redux'
import { useGetAnalyticsQuery } from 'Services/analytics'
import { useGetLocationModulesQuery } from 'Services/institution'
import Clear from '@mui/icons-material/Clear'

interface CIFProps {
  closeModal?: () => void // gets injected from the Modal HOC //
  onFormCompleted?: () => void
  onPersonalizationCompleted?: () => void
}

const CIF = ({
  closeModal,
  onFormCompleted,
  onPersonalizationCompleted,
}: CIFProps) => {
  const { locId, instId, tourId } = useSelector((state: any) => state.location)

  const { data: modulesData, isSuccess: modulesSuccess } =
    useGetLocationModulesQuery({ instId, locId }, { skip: !instId || !locId })

  const isCif = modulesData?.resources.some(
    (module) => module.moduleid === 'registration_cif'
  )

  const { data: analyticsData } = useGetAnalyticsQuery(
    {
      instId,
      locId,
      tourId,
    },
    { skip: !tourId }
  )

  const userkey = analyticsData?.analytics?.userkey
  const token = analyticsData?.analytics?.token
  const sessionid = analyticsData?.analytics?.sessionId

  // legacy form url //
  const legacyForm = `${
    process.env.REACT_APP_BASE_URL
  }registration/${instId}/${locId}?tourid=${tourId}&isMap=1&?typeid=${'college'}`

  // cif url //
  const cifForm = `${
    process.env.REACT_APP_BASE_URL
  }registration-app/latest/index.html#/${instId}/${locId}?cif=1&inst_id=${instId}&loc_id=${locId}&tourid=${tourId}&userkey=${userkey}&source=web&original_source=web&sessionid=${sessionid}&embed=1&embed_type=virtual-tour&typeid=${'college'}&token=${token}`

  // close form when it's completed //
  useEffect(() => {
    const regFormListener = (e) => {
      const formData = e.data
      if (
        formData.message === 'RegistrationForm_Completed' ||
        formData === 'RegistrationForm_Completed'
      ) {
        onFormCompleted()
        closeModal()
      } else if (
        formData.message === 'RegistrationForm_Dismissed' ||
        formData === 'RegistrationForm_Dismissed'
      ) {
        closeModal()
      }
    }

    window.addEventListener('message', regFormListener)
    return () => {
      window.removeEventListener('message', regFormListener)
    }
  }, [closeModal, onFormCompleted, onPersonalizationCompleted])

  return (
    <>
      {isCif && (
        <Button
          aria-label='close form'
          sx={{
            position: 'absolute',
            right: '20px',
            top: '15px',
            color: 'black',
            background: '#fff',
            '&:hover': {
              background: '#fff',
            },
          }}
          variant='text'
          onClick={closeModal}
        >
          <Clear />
        </Button>
      )}

      <Box
        sx={{ width: '100%', height: '100%' }}
        component={'iframe'}
        title='Registration Form'
        src={isCif ? cifForm : legacyForm}
        data-testid='cif-form'
      />
    </>
  )
}

CIF.defaultProps = {
  closeModal: Function,
  onFormCompleted: Function,
  onPersonalizationCompleted: Function,
}

export default CIF
